/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/contact/contact.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/feature/contact/searchphone.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import12 from '../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import13 from '@angular/core/src/zone/ng_zone';
import * as import14 from '../../../../../public/upgrade/core/contract.service';
import * as import15 from '@ngx-translate/core/src/translate.pipe';
import * as import16 from '@angular/core/src/linker/view_container';
import * as import17 from '@angular/core/src/change_detection/change_detection_util';
import * as import18 from '@ngx-translate/core/src/translate.service';
import * as import19 from '@angular/core/src/security';
import * as import20 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import21 from '@angular/core/src/linker/template_ref';
import * as import22 from '@angular/common/src/directives/ng_if';
export class Wrapper_ContactComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ContactComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this._changed = false;
    this.context = new import0.ContactComponent(p0,p1,p2,p3,p4,p5);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_ContactComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_ContactComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.ContactComponent>;
  _SearchPhoneService_0_3:import5.SearchPhoneService;
  _ContactComponent_0_4:Wrapper_ContactComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ContactComponent_Host0,renderType_ContactComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'contact',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ContactComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchPhoneService_0_3 = new import5.SearchPhoneService(this.injectorGet(import9.Http,this.parentIndex));
    this._ContactComponent_0_4 = new Wrapper_ContactComponent(this.injectorGet(import10.ActivatedRoute,this.parentIndex),this.injectorGet(import11.GAService,this.parentIndex),this._SearchPhoneService_0_3,this.injectorGet(import12.SidebarService,this.parentIndex),this.injectorGet(import13.NgZone,this.parentIndex),this.injectorGet(import14.ContractService,this.parentIndex));
    this.compView_0.create(this._ContactComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._ContactComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.SearchPhoneService) && (0 === requestNodeIndex))) { return this._SearchPhoneService_0_3; }
    if (((token === import0.ContactComponent) && (0 === requestNodeIndex))) { return this._ContactComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContactComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const ContactComponentNgFactory:import8.ComponentFactory<import0.ContactComponent> = new import8.ComponentFactory<import0.ContactComponent>('contact',View_ContactComponent_Host0,import0.ContactComponent);
const styles_ContactComponent:any[] = ([] as any[]);
class View_ContactComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  /*private*/ _expr_47:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_49:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_51:any;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  _pipe_translate_2:import15.TranslatePipe;
  /*private*/ _expr_55:any;
  _pipe_translate_3:import15.TranslatePipe;
  /*private*/ _expr_57:any;
  _pipe_translate_4:import15.TranslatePipe;
  /*private*/ _expr_59:any;
  _pipe_translate_5:import15.TranslatePipe;
  /*private*/ _expr_61:any;
  _pipe_translate_6:import15.TranslatePipe;
  /*private*/ _expr_63:any;
  _pipe_translate_7:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_ContactComponent1,renderType_ContactComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_47 = import17.UNINITIALIZED;
    this._expr_49 = import17.UNINITIALIZED;
    this._expr_51 = import17.UNINITIALIZED;
    this._expr_52 = import17.UNINITIALIZED;
    this._expr_53 = import17.UNINITIALIZED;
    this._expr_55 = import17.UNINITIALIZED;
    this._expr_57 = import17.UNINITIALIZED;
    this._expr_59 = import17.UNINITIALIZED;
    this._expr_61 = import17.UNINITIALIZED;
    this._expr_63 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-contact'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','contact-icon -eva-3-icon-xlg eva-3-icon-special-requests -no-margin'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','text-contact'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_12,'a',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'a',new import3.InlineArray4(4,'class','','href','0810 810-8983'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'0810 810-8983',(null as any));
    this._text_20 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'a',new import3.InlineArray4(4,'class','','href','0800 780-08'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'0800 780-08',(null as any));
    this._text_25 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'a',new import3.InlineArray4(4,'class','','href','+52 55 4172-5532'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'+52 55 4172-5532',(null as any));
    this._text_30 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'a',new import3.InlineArray4(4,'class','','href','+56 2 2712-3304'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'+56 2 2712-3304',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'a',new import3.InlineArray4(4,'class','','href','+57 1 580-1355'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'+57 1 580-1355',(null as any));
    this._text_40 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'a',new import3.InlineArray4(4,'class','','href','+55 11 4632-1220'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'+55 11 4632-1220',(null as any));
    this._text_45 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_46 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_13,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_13));
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_4 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_6 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_7 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._text_46
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_47:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('contact.CONTRACT_AND_PROMOS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_47,currVal_47))) {
      this.renderer.setText(this._text_7,currVal_47);
      this._expr_47 = currVal_47;
    }
    valUnwrapper.reset();
    const currVal_49:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('contact.ASK_CONTRACT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_49,currVal_49))) {
      this.renderer.setText(this._text_10,currVal_49);
      this._expr_49 = currVal_49;
    }
    const currVal_51:any = import3.inlineInterpolate(1,'mailto:',this.parentView.context.commercialExecutiveEmail,'');
    if (import3.checkBinding(throwOnChange,this._expr_51,currVal_51)) {
      this.renderer.setElementProperty(this._el_13,'href',this.viewUtils.sanitizer.sanitize(import19.SecurityContext.URL,currVal_51));
      this._expr_51 = currVal_51;
    }
    const currVal_52:any = import3.inlineInterpolate(1,'',this.parentView.context.commercialExecutiveEmail,'');
    if (import3.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setText(this._text_14,currVal_52);
      this._expr_52 = currVal_52;
    }
    valUnwrapper.reset();
    const currVal_53:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('contact.ARGENTINA')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_53,currVal_53))) {
      this.renderer.setText(this._text_17,currVal_53);
      this._expr_53 = currVal_53;
    }
    valUnwrapper.reset();
    const currVal_55:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('contact.PERU')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_55,currVal_55))) {
      this.renderer.setText(this._text_22,currVal_55);
      this._expr_55 = currVal_55;
    }
    valUnwrapper.reset();
    const currVal_57:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('contact.MEXICO')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_57,currVal_57))) {
      this.renderer.setText(this._text_27,currVal_57);
      this._expr_57 = currVal_57;
    }
    valUnwrapper.reset();
    const currVal_59:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('contact.CHILE')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_59,currVal_59))) {
      this.renderer.setText(this._text_32,currVal_59);
      this._expr_59 = currVal_59;
    }
    valUnwrapper.reset();
    const currVal_61:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('contact.COLOMBIA')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_61,currVal_61))) {
      this.renderer.setText(this._text_37,currVal_61);
      this._expr_61 = currVal_61;
    }
    valUnwrapper.reset();
    const currVal_63:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('contact.BRAZIL')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_63,currVal_63))) {
      this.renderer.setText(this._text_42,currVal_63);
      this._expr_63 = currVal_63;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_13(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.notifyGA(this.parentView.context.commercialExecutiveEmail)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ContactComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_19:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_21:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import16.ViewContainer) {
    super(View_ContactComponent2,renderType_ContactComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import17.UNINITIALIZED;
    this._expr_19 = import17.UNINITIALIZED;
    this._expr_21 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','panel-contact'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','contact-icon -eva-3-icon-xlg eva-3-icon-phone -no-margin'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','text-contact'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_12,'label',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('contact.EMERGENCY.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_7,currVal_17);
      this._expr_17 = currVal_17;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('contact.EMERGENCY.text')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_10,currVal_19);
      this._expr_19 = currVal_19;
    }
    const currVal_21:any = import3.inlineInterpolate(1,'',this.parentView.context.selectedCountryPhoneLocalExterior,'');
    if (import3.checkBinding(throwOnChange,this._expr_21,currVal_21)) {
      this.renderer.setText(this._text_14,currVal_21);
      this._expr_21 = currVal_21;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_ContactComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_ContactComponent,{});
export class View_ContactComponent0 extends import1.AppView<import0.ContactComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _anchor_28:any;
  /*private*/ _vc_28:import16.ViewContainer;
  _TemplateRef_28_5:any;
  _NgIf_28_6:import20.Wrapper_NgIf;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _text_65:any;
  _el_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _text_89:any;
  _el_90:any;
  _text_91:any;
  _el_92:any;
  _text_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _text_99:any;
  _el_100:any;
  _text_101:any;
  _el_102:any;
  _text_103:any;
  _text_104:any;
  _text_105:any;
  _text_106:any;
  _anchor_107:any;
  /*private*/ _vc_107:import16.ViewContainer;
  _TemplateRef_107_5:any;
  _NgIf_107_6:import20.Wrapper_NgIf;
  _text_108:any;
  _text_109:any;
  _text_110:any;
  _text_111:any;
  _text_112:any;
  _text_113:any;
  /*private*/ _expr_120:any;
  _pipe_translate_0:import15.TranslatePipe;
  /*private*/ _expr_122:any;
  _pipe_translate_1:import15.TranslatePipe;
  /*private*/ _expr_124:any;
  _pipe_translate_2:import15.TranslatePipe;
  /*private*/ _expr_126:any;
  _pipe_translate_3:import15.TranslatePipe;
  /*private*/ _expr_128:any;
  _pipe_translate_4:import15.TranslatePipe;
  /*private*/ _expr_130:any;
  _pipe_translate_5:import15.TranslatePipe;
  /*private*/ _expr_132:any;
  _pipe_translate_6:import15.TranslatePipe;
  /*private*/ _expr_134:any;
  _pipe_translate_7:import15.TranslatePipe;
  /*private*/ _expr_136:any;
  _pipe_translate_8:import15.TranslatePipe;
  /*private*/ _expr_138:any;
  _pipe_translate_9:import15.TranslatePipe;
  /*private*/ _expr_140:any;
  _pipe_translate_10:import15.TranslatePipe;
  /*private*/ _expr_142:any;
  _pipe_translate_11:import15.TranslatePipe;
  /*private*/ _expr_144:any;
  _pipe_translate_12:import15.TranslatePipe;
  /*private*/ _expr_146:any;
  _pipe_translate_13:import15.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ContactComponent0,renderType_ContactComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_120 = import17.UNINITIALIZED;
    this._expr_122 = import17.UNINITIALIZED;
    this._expr_124 = import17.UNINITIALIZED;
    this._expr_126 = import17.UNINITIALIZED;
    this._expr_128 = import17.UNINITIALIZED;
    this._expr_130 = import17.UNINITIALIZED;
    this._expr_132 = import17.UNINITIALIZED;
    this._expr_134 = import17.UNINITIALIZED;
    this._expr_136 = import17.UNINITIALIZED;
    this._expr_138 = import17.UNINITIALIZED;
    this._expr_140 = import17.UNINITIALIZED;
    this._expr_142 = import17.UNINITIALIZED;
    this._expr_144 = import17.UNINITIALIZED;
    this._expr_146 = import17.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','-h1'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray2(2,'class','heading-example'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'h6',new import3.InlineArray2(2,'class','eva-3-h6'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_18,'\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_16,'\n                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-lg'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._anchor_28 = this.renderer.createTemplateAnchor(this._el_26,(null as any));
    this._vc_28 = new import16.ViewContainer(28,26,this,this._anchor_28);
    this._TemplateRef_28_5 = new import21.TemplateRef_(this,28,this._anchor_28);
    this._NgIf_28_6 = new import20.Wrapper_NgIf(this._vc_28.vcRef,this._TemplateRef_28_5);
    this._text_29 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','panel-contact'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'i',new import3.InlineArray2(2,'class','contact-icon -eva-3-icon-xlg eva-3-icon-laptop -no-margin'),(null as any));
    this._text_35 = this.renderer.createText(this._el_32,'\n\n                            ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'Extranet',(null as any));
    this._text_38 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','text-contact'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'',(null as any));
    this._text_41 = this.renderer.createText(this._el_32,'\n\n                            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'a',new import3.InlineArray4(4,'class','','href','mailto:atencionautos@despegar.com'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'atencionautos@despegar.com',(null as any));
    this._text_46 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_32,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'a',new import3.InlineArray4(4,'class','','href','mailto:atendimentoautos@decolar.com'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'atendimentoautos@decolar.com',(null as any));
    this._text_51 = this.renderer.createText(this._el_32,'\n                        ',(null as any));
    this._text_52 = this.renderer.createText(this._el_30,'\n                    ',(null as any));
    this._text_53 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                        ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'div',new import3.InlineArray2(2,'class','panel-contact'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_56,'i',new import3.InlineArray2(2,'class','contact-icon -eva-3-icon-xlg eva-3-icon-tickets -no-margin'),(null as any));
    this._text_59 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_56,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'',(null as any));
    this._text_62 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_56,'p',new import3.InlineArray2(2,'class','text-contact'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'',(null as any));
    this._text_65 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_66 = import3.createRenderElement(this.renderer,this._el_56,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_67 = this.renderer.createText(this._el_66,'',(null as any));
    this._el_68 = import3.createRenderElement(this.renderer,this._el_66,'a',new import3.InlineArray4(4,'class','','href','mailto:solucionesautos@despegar.com'),(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'solucionesautos@despegar.com',(null as any));
    this._text_70 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_56,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'a',new import3.InlineArray4(4,'class','','href','mailto:atendimentocarros@decolar.com'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'atendimentocarros@decolar.com',(null as any));
    this._text_75 = this.renderer.createText(this._el_56,'\n                        ',(null as any));
    this._text_76 = this.renderer.createText(this._el_54,'\n                    ',(null as any));
    this._text_77 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-mt-lg'),(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'\n                        ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_78,'div',new import3.InlineArray2(2,'class','panel-contact'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'i',new import3.InlineArray2(2,'class','contact-icon -eva-3-icon-xlg eva-3-icon-budget -no-margin'),(null as any));
    this._text_83 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','title-contact'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'',(null as any));
    this._text_86 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','text-contact'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'',(null as any));
    this._text_89 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_90 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_91 = this.renderer.createText(this._el_90,'',(null as any));
    this._el_92 = import3.createRenderElement(this.renderer,this._el_90,'a',new import3.InlineArray4(4,'class','','href','mailto:ast@despegar.com'),(null as any));
    this._text_93 = this.renderer.createText(this._el_92,'ast@despegar.com',(null as any));
    this._text_94 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_95 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'',(null as any));
    this._el_97 = import3.createRenderElement(this.renderer,this._el_95,'a',new import3.InlineArray4(4,'class','','href','mailto:informe.autos@decolar.com'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'informe.autos@decolar.com',(null as any));
    this._text_99 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_100 = import3.createRenderElement(this.renderer,this._el_80,'p',new import3.InlineArray2(2,'class','detail-contact'),(null as any));
    this._text_101 = this.renderer.createText(this._el_100,'',(null as any));
    this._el_102 = import3.createRenderElement(this.renderer,this._el_100,'a',new import3.InlineArray4(4,'class','','href','mailto:financeiro.autos@decolar.com'),(null as any));
    this._text_103 = this.renderer.createText(this._el_102,'financeiro.autos@decolar.com',(null as any));
    this._text_104 = this.renderer.createText(this._el_80,'\n                        ',(null as any));
    this._text_105 = this.renderer.createText(this._el_78,'\n                    ',(null as any));
    this._text_106 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._anchor_107 = this.renderer.createTemplateAnchor(this._el_26,(null as any));
    this._vc_107 = new import16.ViewContainer(107,26,this,this._anchor_107);
    this._TemplateRef_107_5 = new import21.TemplateRef_(this,107,this._anchor_107);
    this._NgIf_107_6 = new import20.Wrapper_NgIf(this._vc_107.vcRef,this._TemplateRef_107_5);
    this._text_108 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_109 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_110 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_111 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_112 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_113 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_44,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_44));
    this._pipe_translate_4 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_49,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_49));
    this._pipe_translate_5 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_68,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_68));
    this._pipe_translate_8 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_73,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_73));
    this._pipe_translate_9 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_11 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_92,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_92));
    this._pipe_translate_12 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_97,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_97));
    this._pipe_translate_13 = new import15.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_102,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_102));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._anchor_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._el_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._text_89,
      this._el_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._text_99,
      this._el_100,
      this._text_101,
      this._el_102,
      this._text_103,
      this._text_104,
      this._text_105,
      this._text_106,
      this._anchor_107,
      this._text_108,
      this._text_109,
      this._text_110,
      this._text_111,
      this._text_112,
      this._text_113
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (28 === requestNodeIndex))) { return this._TemplateRef_28_5; }
    if (((token === import22.NgIf) && (28 === requestNodeIndex))) { return this._NgIf_28_6.context; }
    if (((token === import21.TemplateRef) && (107 === requestNodeIndex))) { return this._TemplateRef_107_5; }
    if (((token === import22.NgIf) && (107 === requestNodeIndex))) { return this._NgIf_107_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import17.ValueUnwrapper();
    const currVal_28_0_0:boolean = !!this.context.commercialExecutiveEmail;
    this._NgIf_28_6.check_ngIf(currVal_28_0_0,throwOnChange,false);
    this._NgIf_28_6.ngDoCheck(this,this._anchor_28,throwOnChange);
    const currVal_107_0_0:boolean = !!this.context.selectedCountryPhoneLocalExterior;
    this._NgIf_107_6.check_ngIf(currVal_107_0_0,throwOnChange,false);
    this._NgIf_107_6.ngDoCheck(this,this._anchor_107,throwOnChange);
    this._vc_28.detectChangesInNestedViews(throwOnChange);
    this._vc_107.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_120:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('contact.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_120,currVal_120))) {
      this.renderer.setText(this._text_13,currVal_120);
      this._expr_120 = currVal_120;
    }
    valUnwrapper.reset();
    const currVal_122:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('contact.SUBTITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_122,currVal_122))) {
      this.renderer.setText(this._text_21,currVal_122);
      this._expr_122 = currVal_122;
    }
    valUnwrapper.reset();
    const currVal_124:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('contact.HELP')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_124,currVal_124))) {
      this.renderer.setText(this._text_40,currVal_124);
      this._expr_124 = currVal_124;
    }
    valUnwrapper.reset();
    const currVal_126:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('contact.LATAM')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_126,currVal_126))) {
      this.renderer.setText(this._text_43,currVal_126);
      this._expr_126 = currVal_126;
    }
    valUnwrapper.reset();
    const currVal_128:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('contact.BRAZIL')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_128,currVal_128))) {
      this.renderer.setText(this._text_48,currVal_128);
      this._expr_128 = currVal_128;
    }
    valUnwrapper.reset();
    const currVal_130:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('contact.BOOKINGS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_130,currVal_130))) {
      this.renderer.setText(this._text_61,currVal_130);
      this._expr_130 = currVal_130;
    }
    valUnwrapper.reset();
    const currVal_132:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('contact.ASK_BOOKING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_132,currVal_132))) {
      this.renderer.setText(this._text_64,currVal_132);
      this._expr_132 = currVal_132;
    }
    valUnwrapper.reset();
    const currVal_134:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('contact.LATAM')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_134,currVal_134))) {
      this.renderer.setText(this._text_67,currVal_134);
      this._expr_134 = currVal_134;
    }
    valUnwrapper.reset();
    const currVal_136:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('contact.BRAZIL')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_136,currVal_136))) {
      this.renderer.setText(this._text_72,currVal_136);
      this._expr_136 = currVal_136;
    }
    valUnwrapper.reset();
    const currVal_138:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('contact.CHARGES_AND_PAYMENTS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_138,currVal_138))) {
      this.renderer.setText(this._text_85,currVal_138);
      this._expr_138 = currVal_138;
    }
    valUnwrapper.reset();
    const currVal_140:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform('contact.ASK_PAYMENTS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_140,currVal_140))) {
      this.renderer.setText(this._text_88,currVal_140);
      this._expr_140 = currVal_140;
    }
    valUnwrapper.reset();
    const currVal_142:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('contact.LATAM')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_142,currVal_142))) {
      this.renderer.setText(this._text_91,currVal_142);
      this._expr_142 = currVal_142;
    }
    valUnwrapper.reset();
    const currVal_144:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform('contact.BRAZIL')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_144,currVal_144))) {
      this.renderer.setText(this._text_96,currVal_144);
      this._expr_144 = currVal_144;
    }
    valUnwrapper.reset();
    const currVal_146:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_13.transform('contact.BRAZIL_VCC')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_146,currVal_146))) {
      this.renderer.setText(this._text_101,currVal_146);
      this._expr_146 = currVal_146;
    }
  }
  destroyInternal():void {
    this._vc_28.destroyNestedViews();
    this._vc_107.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 28)) { return new View_ContactComponent1(this.viewUtils,this,28,this._anchor_28,this._vc_28); }
    if ((nodeIndex == 107)) { return new View_ContactComponent2(this.viewUtils,this,107,this._anchor_107,this._vc_107); }
    return (null as any);
  }
  handleEvent_44(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('atencionautos@despegar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_49(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('atendimentoautos@decolar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_68(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('solucionesautos@despegar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_73(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('atendimentocarros@decolar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_92(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('ast@despegar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_97(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('informe.autos@decolar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_102(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.notifyGA('financeiro.autos@decolar.com')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/contact/contact.component.ngfactory.ts